// extracted by mini-css-extract-plugin
export default {"ml6":"tooltipExpression_ml6__nmsDo","operatorDivide":"tooltipExpression_operatorDivide__L+3yA","textCenter":"tooltipExpression_textCenter__E4wJn"};